import { Commission } from "../../domain/models/Commission";

export class CommissionRow {
    title?: string;
    commission?: Commission;

    constructor({
        title = undefined,
        commission = undefined
    }: any) {
        this.title = title;
        this.commission = commission;
    }
}